{
  "title": "Compartilhar sua localização permite agilizar o processo de check-in",
  "body": "Lamentamos, mas não conseguimos concluir o seu check-in sem acesso à sua localização. Por favor, conceda permissão de localização para continuar. Usamos sua localização apenas para fins de check-in no armazém e não armazenamos nem compartilhamos suas informações de localização com terceiros.",
  "shareLocation": "Compartilhar minha localização"
}
